import { Animated } from "react-native";

import BigList from "./BigList";

export default Animated.createAnimatedComponent(BigList);
